module.exports = __webpack_public_path__ + "img/masterAdmins.5f17d327.svg";